import { Controller } from "@hotwired/stimulus"

const SITE_KEY = "6LcNrIksAAAAAD8eck5EElu_4Fv9JJWUcSf-dw3x"
const SCRIPT_SRC = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`

export default class extends Controller {
  connect() {
    this.scriptRequested = false
    this.load = this.loadRecaptcha.bind(this)
    // Only pull in the reCAPTCHA script once the visitor actually engages with
    // the form — not on initial page load.
    this.element.addEventListener("focusin", this.load, { once: true })
    this.element.addEventListener("pointerdown", this.load, { once: true })
  }

  disconnect() {
    this.element.removeEventListener("focusin", this.load)
    this.element.removeEventListener("pointerdown", this.load)
  }

  loadRecaptcha() {
    if (this.scriptRequested) return
    this.scriptRequested = true
    const script = document.createElement("script")
    script.src = SCRIPT_SRC
    script.async = true
    script.defer = true
    document.head.appendChild(script)
  }

  async submit(event) {
    event.preventDefault()
    this.loadRecaptcha() // safety net if no interaction event fired first

    try {
      const token = await Promise.race([
        this.executeWhenReady(),
        new Promise((_, reject) => setTimeout(() => reject(new Error("timeout")), 5000))
      ])
      if (token) {
        const field = document.getElementById("g-recaptcha-response-data-contact")
        if (field) field.value = token
      }
    } catch (e) {
      console.warn("reCAPTCHA error:", e)
    }

    this.element.submit()
  }

  // Wait for the lazily-injected script to define `grecaptcha`, then run it.
  executeWhenReady() {
    return this.waitForGrecaptcha().then(
      () =>
        new Promise((resolve, reject) => {
          grecaptcha.ready(() => {
            grecaptcha.execute(SITE_KEY, { action: "contact" }).then(resolve).catch(reject)
          })
        })
    )
  }

  waitForGrecaptcha() {
    return new Promise((resolve, reject) => {
      if (typeof grecaptcha !== "undefined") return resolve()
      const start = Date.now()
      const interval = setInterval(() => {
        if (typeof grecaptcha !== "undefined") {
          clearInterval(interval)
          resolve()
        } else if (Date.now() - start > 4000) {
          clearInterval(interval)
          reject(new Error("grecaptcha not loaded"))
        }
      }, 100)
    })
  }
}
